import React from 'react';
import { format } from 'date-fns';

interface DaySelectorProps {
  days: Date[];
  selectedIndex: number;
  onSelect: (index: number) => void;
}

const DaySelector: React.FC<DaySelectorProps> = ({ days, selectedIndex, onSelect }) => {
  const handleDayClick = (index: number) => {
    onSelect(index);
  };

  return (
    <div className="flex gap-2 overflow-x-auto pb-2 -mx-4 px-4 scrollbar-hide">
      {days.map((day, index) => {
        const isSelected = index === selectedIndex;
        const dayName = format(day, 'EEE');
        const dayNumber = format(day, 'd');
        const isToday = format(day, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');
        const dayKey = format(day, 'yyyy-MM-dd'); // Use date as key for stability

        return (
          <button
            key={dayKey}
            onClick={() => handleDayClick(index)}
            type="button"
            className={`
              flex-shrink-0 flex flex-col items-center justify-center
              min-w-[60px] h-16 px-3 rounded-lg
              transition-all duration-200
              focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2
              touch-manipulation
              ${
                isSelected
                  ? 'bg-primary-500 text-white shadow-md scale-105'
                  : isToday
                  ? 'bg-primary-100 text-primary-700 border-2 border-primary-300'
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'
              }
            `}
            aria-label={`Select ${format(day, 'EEEE, MMMM d')}`}
            aria-pressed={isSelected}
          >
            <span className={`text-xs font-medium ${isSelected ? 'text-white' : 'text-gray-500'}`}>
              {dayName}
            </span>
            <span className={`text-lg font-bold ${isSelected ? 'text-white' : 'text-gray-900'}`}>
              {dayNumber}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default DaySelector;

